import React from 'react';
import PatternGalleries from './PatternGalleries';
import {connect} from 'react-redux';
import {getMessage} from "../../reducers/i18n";
import {getGalleryData} from "../../reducers/patterns";
import {getCurrentRouteDesigner} from "../../reducers/designer";
import {defineMessages} from "react-intl";
import {sortNumberDesc} from "../../helper/utils";

defineMessages({
    labelMore: {
        id: "DESIGNER_PATTERNGALLERY_TITLE",
        description: "Label text for more menu icon",
        defaultMessage: "Stoff-Motive von"
    },
});

const DesignerGallery = ( props ) => {
    return (
        <PatternGalleries {...props} />
    );
};

const makeMapStateToProps = ( initialState ) => {
    const title = getMessage( initialState, "DESIGNER_PATTERNGALLERY_TITLE" );
    return ( state ) => {
        const designer = getCurrentRouteDesigner(state);
        const {totalHits, patterns, items} = getGalleryData( state );
        var sorted = items.sort(sortNumberDesc);
        return {
            title   : totalHits + ' ' + title + ' ' + designer.display,
            patterns: patterns,
            items: sorted,
            totalHits: totalHits,
        }
    }
};

export default connect( makeMapStateToProps )( DesignerGallery );



// WEBPACK FOOTER //
// ./src/components/patterngalleries/DesignerGallery.js